// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"4af02294","455":"dc600e84"}[chunkId] + ".chunk.js";
};